import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { lyricsSections } from '@/mocks/album';
import { useLanguage } from '@/i18n/useLanguage';

// 言語はサイト全体で1つ（Navbar のトグル）。このページはかつて独自の useState を持っていて、
// トップや /liner-notes と食い違っていた。2026-08-15 に統合。

export default function Lyrics() {
  const { t } = useTranslation();
  const lang = useLanguage();

  return (
    <>
      <Navbar />
      <main className="min-h-screen pt-24 pb-20 bg-background-50">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <p className="text-xs tracking-[0.3em] text-secondary-500 mb-3">LYRICS</p>
            <h1 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
              Who is the machine?
            </h1>
            <p className="text-sm text-foreground-600">Gen.Y.Sakai</p>
          </div>

          <div className="space-y-10">
            {lyricsSections.map((section, index) => (
              <div key={index} className="space-y-3">
                <p className="text-xs tracking-[0.2em] text-primary-400 font-medium">
                  [{section.label}]
                </p>
                <div className="space-y-1">
                  {section[lang].map((line, lineIdx) => (
                    <p
                      key={lineIdx}
                      className={`text-sm md:text-base leading-relaxed ${
                        line === '' ? 'h-4' : 'text-foreground-800'
                      }`}
                    >
                      {line}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 text-center">
            <p className="text-xs text-foreground-500 tracking-wider">
              {t('lyrics.note')}
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}